import axios from "axios"
import { TallyConfig } from "../helpers/constants"
import { xmlToJs } from "../helpers/xmltojs"
import * as moment from "moment"
import hash from 'object-hash'
import { getKeysFromLocalDB } from "../helpers/getKeysFromLocalDB"
import { SyncStockItems } from "../sync/items"
import { xmlFormatter } from "../helpers/xmlFormatter"

export async function GetStockItems(startDate, endDate) {

    let syncFromDate = startDate
    syncFromDate = moment(syncFromDate).format("YYYYMMDD")

    let currentDate = moment(endDate).format("YYYYMMDD")

    let alterId = parseInt(window.localStorage.getItem(`tally-${TallyConfig.company}-altId`)) || 0

    let filter = `$alterid &gt; ${alterId} AND $MASTERID &gt; 0`

    let data = `
    <ENVELOPE>
        <HEADER>
            <VERSION>1</VERSION>
            <TALLYREQUEST>Export</TALLYREQUEST>
            <TYPE>Collection</TYPE>
            <ID>Collection of Ledgers</ID>
        </HEADER>
        <BODY>
            <DESC>
                <STATICVARIABLES>
                    <SVEXPORTFORMAT>$$SysName:XML</SVEXPORTFORMAT>
                    <SVCURRENTCOMPANY>${TallyConfig.company}</SVCURRENTCOMPANY>
                    <SVFROMDATE TYPE="Date">${syncFromDate}</SVFROMDATE>
                    <SVTODATE TYPE="Date">${currentDate}</SVTODATE>
                </STATICVARIABLES>
                <TDL>
                    <TDLMESSAGE>
                        <COLLECTION NAME="Collection of Ledgers" ISMODIFY="NO">
                            <FILTER>StockItemsfilter</FILTER>
                            <FETCH>GUID,ALTERID,MASTERID,NAME,DESCRIPTION,OPENINGRATE,PARENT,CATEGORY,BASEUNITS,ADDITIONALUNITS,DENOMINATOR,CONVERSION,BATCHALLOCATIONS.LIST,LASTSALEDATE,GSTDETAILS.LIST,GSTAPPLICABLE,LANGUAGENAME.LIST,MAILINGNAME.LIST,REORDERBASE,MINIMUMORDERBASE,FULLPRICELIST.LIST,STANDARDCOSTLIST.LIST,STANDARDPRICELIST.LIST,DESCRIPTION,IGNOREPHYSICALDIFFERENCE,COSTINGMETHOD,VALUATIONMETHOD,ISCOSTCENTRESON,ISPERISHABLEON,MRPDETAILS.LIST,VATDETAILS.LIST,VATAPPLICABLE,REORDERASHIGHER,MINORDERASHIGHER,GSTSLABRATES.LIST,GSTTYPEOFSUPPLY,COSTINGMETHOD,ISBATCHWISEON,HSNDETAILS.LIST</FETCH>
                            <TYPE>StockItem</TYPE>
                        </COLLECTION>
                        <SYSTEM TYPE="FORMULAE" NAME="StockItemsfilter">${filter}</SYSTEM>
                    </TDLMESSAGE>
                </TDL>
            </DESC>
        </BODY>
    </ENVELOPE>
    `

    data = xmlFormatter(data)

    try {
        let resp = await window.electron.tallyConnect({
            url: `${TallyConfig.host}:${TallyConfig.port}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
            },
            timeout: 500000,
            data: data
        })
        if (resp.status === 200) {
            let jsonData = resp?.data

            if(!jsonData?.ENVELOPE?.BODY?.DATA?.COLLECTION?.STOCKITEM){
                return {
                    change: false,
                    status: true
                }
            }

            await SyncStockItems(jsonData)

            return {
                change: true,
                status: true
            }
        } else {
            return false
        }
    } catch (err) {
        console.log("error in stockItems", err)
        return false
    }
}
// export async function GetStockCategories() {

//     let data = `
//     <ENVELOPE>
//     <HEADER>
//         <VERSION>1</VERSION>
//         <TALLYREQUEST>Export</TALLYREQUEST>
//         <TYPE>Collection</TYPE>
//         <ID>Custom List of StockItems</ID>
//     </HEADER>
//     <BODY>
//         <DESC>
//             <STATICVARIABLES>
//                 <SVCURRENTCOMPANY>${TallyConfig.company}</SVCURRENTCOMPANY>
//                 <SVEXPORTFORMAT>$$SysName:XML</SVEXPORTFORMAT>
//             </STATICVARIABLES>
//             <TDL>
//                 <TDLMESSAGE>
//                     <COLLECTION ISMODIFY="No" ISFIXED="No" ISINITIALIZE="Yes" ISOPTION="No" ISINTERNAL="No" NAME="Custom List of StockItems">
//                         <TYPE>StockItem</TYPE>
//                         <FETCH>
//                             MASTERID,
//                             GUID,
//                             NAME,
//                             PARENT,
//                             CATEGORY,
//                             NARRATION,
//                             OPENINGBALANCE,
//                             BATCHALLOCATIONS,
//                             STANDARDPRICE,
//                             GSTDETAILS,
//                             RATEDETAILS,
//                             MRPRATEDETAILS,
//                             STANDARDCOST
//                         </FETCH>
//                     </COLLECTION>
//                 </TDLMESSAGE>
//             </TDL>
//         </DESC>
//     </BODY>
// </ENVELOPE>
//     `

//     data = xmlFormatter(data)

//     try {
//         let resp = await window.electron.tallyConnect({
//             url: `${TallyConfig.host}:${TallyConfig.port}`,
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/xml',
//             },
//             timeout: 500000,
//             data: data
//         })
//         console.log(resp)
//         if (resp.status === 200) {
//             let jsonData = await xmlToJs(resp.data)

//             if(!jsonData){
//                 return false
//             }

//             window.localStorage.setItem("tally-stcok-categories", JSON.stringify(jsonData))

//             return jsonData
//         } else {
//             return false
//         }
//     } catch (err) {
//         return false
//     }
// }

// export async function GetStockGroups() {

//     let data = `
//     <ENVELOPE>
//     <HEADER>
//         <VERSION>1</VERSION>
//         <TALLYREQUEST>Export</TALLYREQUEST>
//         <TYPE>Collection</TYPE>
//         <ID>Custom List of StockItems</ID>
//     </HEADER>
//     <BODY>
//         <DESC>
//             <STATICVARIABLES>
//                 <SVCURRENTCOMPANY>${TallyConfig.company}</SVCURRENTCOMPANY>
//                 <SVEXPORTFORMAT>$$SysName:XML</SVEXPORTFORMAT>
//             </STATICVARIABLES>
//             <TDL>
//                 <TDLMESSAGE>
//                     <COLLECTION ISMODIFY="No" ISFIXED="No" ISINITIALIZE="Yes" ISOPTION="No" ISINTERNAL="No" NAME="Custom List of StockItems">
//                         <TYPE>StockItem</TYPE>
//                         <FETCH>
//                             MASTERID,
//                             GUID,
//                             NAME,
//                             PARENT,
//                             CATEGORY,
//                             NARRATION,
//                             OPENINGBALANCE,
//                             BATCHALLOCATIONS,
//                             STANDARDPRICE,
//                             GSTDETAILS,
//                             RATEDETAILS,
//                             MRPRATEDETAILS,
//                             STANDARDCOST
//                         </FETCH>
//                     </COLLECTION>
//                 </TDLMESSAGE>
//             </TDL>
//         </DESC>
//     </BODY>
// </ENVELOPE>
//     `

//     data = xmlFormatter(data)

//     try {
//         let resp = await window.electron.tallyConnect({
//             url: `${TallyConfig.host}:${TallyConfig.port}`,
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/xml',
//             },
//             timeout: 500000,
//             data: data
//         })
//         console.log(resp)
//         if (resp.status === 200) {
//             let jsonData = await xmlToJs(resp.data)

//             if(!jsonData){
//                 return false
//             }

//             window.localStorage.setItem("tally-stcok-groups", JSON.stringify(jsonData))

//             return jsonData
//         } else {
//             return false
//         }
//     } catch (err) {
//         return false
//     }
// }